import { isUserVip } from "./vip/isUserVip";

export const getGoatGifts = (user) =>
  Number(user?.goatGifts ?? user?.user?.goatGifts ?? 0) || 0;
export const getClownGifts = (user) =>
  Number(user?.clownGifts ?? user?.user?.clownGifts ?? 0) || 0;

export const getAvatarFrameType = (user) => {
  if (!user) return null;

  const goatGifts = getGoatGifts(user);
  const clownGifts = getClownGifts(user);

  if (clownGifts > goatGifts) return "clown";
  if (goatGifts > 0) return "goat";
  if (isUserVip(user)) return "vip";
  return null;
};
